import CustomInput from '../../reusable/input';
import CustomModal from '../../modals';
import { nameSchema } from '../../../schema';
import { Box, Button } from '@mui/material';
import { Form, Formik } from 'formik';

/**
 * @heading1: AddPipelineModal
 * @paragraph: A modal component for adding a new pipeline. Uses Formik for form handling
 * and integrates with Redux for pipeline creation.
 * @param: {boolean} open - Whether the modal is open or not.
 * @param: {function} onClose - Function to close the modal.
 */

const AddLinkModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * initialValues: {PipelineParams} -  Initial form values for the pipeline creation form.
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders: An object containing the loader details from the Redux store.
     */
    // Initial form values for the pipeline creation form
    const initialValues = {
        name: ''
    };

    /**
     * @heading3: Functions
     * @heading4: Handles the form submission by dispatching a Redux thunk.
     * @param: {PipelineParams} values - The form values for creating a pipeline.
     */
    const handleSubmit = () => {
        try {
            // dispatch(editFormTitle(values.name));
            // Close the modal on successful submission
            onClose();
        } catch (e) {
            // Catch errors
        }
    };

    return <CustomModal open={open} handleClose={onClose} title="Add Website">
        <Formik
            initialValues={initialValues}
            validationSchema={nameSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, errors, touched }) => (
                <Form>
                    {/* Input field for pipeline name */}
                    <CustomInput
                        value={values.name}
                        onChange={handleChange('name')}
                        onBlur={handleBlur('name')}
                        error={touched.name && errors.name}
                        fullWidth
                        label="Website URL"
                        placeholder="Enter url"
                        variant="outlined"
                    />
                    {/* Action buttons for form submission or cancellation */}
                    <Box display="flex" gap={2} mt={2}>
                        <Button variant="outlined" color="primary" onClick={onClose} fullWidth>
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Add
                        </Button>
                    </Box>
                </Form>
            )}
        </Formik>
    </CustomModal>;
};

export default AddLinkModal;